import { render, staticRenderFns } from "./ProjRec.vue?vue&type=template&id=1ff9a69a&scoped=true&lang=pug&"
import script from "./ProjRec.vue?vue&type=script&lang=js&"
export * from "./ProjRec.vue?vue&type=script&lang=js&"
import style0 from "./ProjRec.vue?vue&type=style&index=0&id=1ff9a69a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff9a69a",
  null
  
)

export default component.exports